<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="flex-grow-1 input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
    <div class="input-field" style="width: 350px;">
        <p-dropdown placeholder="Tipo" [options]="transactionsTypes" optionLabel="name" optionValue="id"
            [(ngModel)]="filters.transactionTypeId.value" (onChange)="search()" showClear />
    </div>
</div>
-->

<p-table #grid [value]="transactionsSeries" [lazy]="true" (onLazyLoad)="loadData($event)"
    [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="prefix">Prefijo <p-sortIcon field="prefix"></p-sortIcon></th>
            <th pSortableColumn="returnPrefix">Prefijo de abono <p-sortIcon field="returnPrefix"></p-sortIcon></th>
            <th pSortableColumn="numberLength">Longitud de número <p-sortIcon field="numberLength"></p-sortIcon></th>
            <th pSortableColumn="firstNumber">Primer número <p-sortIcon field="firstNumber"></p-sortIcon></th>
            <th pSortableColumn="transactionType.name">Tipo de transacción <p-sortIcon
                    field="transactionType.name"></p-sortIcon>
            </th>
            <th pSortableColumn="active">Activo <p-sortIcon field="active"></p-sortIcon></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transactionSerie let-columns="columns">
        <tr (dblclick)="edit(transactionSerie)">
            <td>{{transactionSerie.name}}</td>
            <td>{{transactionSerie.prefix}}</td>
            <td>{{transactionSerie.returnPrefix}}</td>
            <td>{{transactionSerie.numberLength}}</td>
            <td>{{transactionSerie.firstNumber}}</td>
            <td>{{transactionSerie.transactionType?.name}}</td>
            <td>
                <i class="pi"
                    [ngClass]="{ 'text-green-500 pi-check-circle': transactionSerie.active, 'text-red-500 pi-times-circle': !transactionSerie.active }"></i>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(transactionSerie)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(transactionSerie)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>